import { gql } from '@apollo/client';

const ExtensibilityQuery = gql`
  query Extensions {
    devhub {
      extensions {
        id
        name
        owner
        extensionType
        distributionList
        slackChannel
        notes
        securityCredentialsUrl
      }
    }
  }
`;

export default ExtensibilityQuery;
